import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AuthenticationService } from "../../services/authentication.service";
import { UserService } from "../../services/user-service.service";
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { FarmService } from 'src/app/services/farm-service.service';
import { environment } from '../../../environments/environment';
import { Directive, ElementRef } from '@angular/core';
declare var $: any;


@Component({
  selector: "smart-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"]
})
export class LoginComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }



}
